module.exports = __webpack_public_path__ + "img/10.c5b32cb1.png";